export default {
    async: {
        type: Object,
        default: undefined
    }, 
    directory: {
        type: Boolean,
        default: undefined
    }, 
    directoryDrop: {
        type: Boolean,
        default: undefined
    }, 
    dropZone: {
        type: String,
        default: undefined
    }, 
    enabled: {
        type: Boolean,
        default: undefined
    }, 
    files: {
        type: Array,
        default: undefined
    }, 
    localization: {
        type: Object,
        default: undefined
    }, 
    multiple: {
        type: Boolean,
        default: undefined
    }, 
    showFileList: {
        type: Boolean,
        default: undefined
    }, 
    template: {
        type: [String, Function],
        default: undefined
    }, 
    validation: {
        type: Object,
        default: undefined
    }, 

    // Events
    cancel: Function, 
    clear: Function, 
    complete: Function, 
    error: Function, 
    pause: Function, 
    progress: Function, 
    resume: Function, 
    remove: Function, 
    select: Function, 
    success: Function, 
    upload: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/KendoUpload/UploadProps.js